import { dsLogger } from '../../shared/services/logger/logger.instance';

export const selectItemDialogLogger = dsLogger.extend('select-item-dialog');
